import { VideoTemplateStateContent } from 'components/VideoTemplateEditor/types';
import { TemplateAction } from '../../action-types';
import {
  addTextOverlay,
  deleteTextOverlay,
  setTextDimensions,
  updateImmutableTextOverlay,
} from './mutations';

export default function reducer(
  state: VideoTemplateStateContent,
  action: TemplateAction,
): VideoTemplateStateContent {
  switch (action.type) {
    case 'TEXT_ADD': {
      const { textOverlay, integrationData } = action.payload;
      return addTextOverlay(state, textOverlay, { integrationData });
    }

    case 'TEXT_DIMENSIONS_CHANGE': {
      const { dimensions, id } = action.payload;
      return setTextDimensions(state, id, dimensions);
    }

    case 'TEXT_DELETE': {
      const { payload: id } = action;
      return deleteTextOverlay(state, id);
    }

    case 'TEXT_UPDATE': {
      const {
        payload: { id, textOverlay },
      } = action;

      return updateImmutableTextOverlay(state, id, textOverlay);
    }

    default:
      return state;
  }
}
